
namespace SorAraBul.PropertyManagement {

    import fld = TenantsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TenantsGrid extends Serenity.EntityGrid<TenantsRow, any> {
        protected getColumnsKey() { return TenantsColumns.columnsKey; }
        protected getDialogType() { return TenantsDialog; }
        protected getIdProperty() { return TenantsRow.idProperty; }
        protected getInsertPermission() { return TenantsRow.insertPermission; }
        protected getLocalTextPrefix() { return TenantsRow.localTextPrefix; }
        protected getService() { return TenantsService.baseUrl; }

        private insufficientCreditDialog: JQuery;
        private tenantSummary: JQuery;
        private activeStatusFilter: TenantStatus;

        constructor(container: JQuery) {
            super(container);

            this.element.addClass('tenant-operations-grid');
            this.createTenantSummary();
            SorAraBul.Common.Functions.addAndUpdateCreditInfo(this.element);
        }

        refresh() {
            super.refresh();

            SorAraBul.Common.Functions.addAndUpdateCreditInfo(this.element);
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.rowHeight = 46;
            return opt;
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            this.view.params.EqualityFilter = this.view.params.EqualityFilter || {};

            if (this.activeStatusFilter != null)
                this.view.params.EqualityFilter[fld.Status] = this.activeStatusFilter;
            else
                delete this.view.params.EqualityFilter[fld.Status];

            return true;
        }

        protected onViewProcessData(response: Serenity.ListResponse<TenantsRow>) {
            response = super.onViewProcessData(response);
            this.updateTenantSummary(response.Entities || [], response.TotalCount || 0);
            return response;
        }

        protected getItemCssClass(item: TenantsRow, index: number): string {
            let klass: string = "";

            if (item.Status == TenantStatus.formGonderildi)
                klass += " g-formGonderildi";
            else if (item.Status == TenantStatus.raporHazirlaniyor)
                klass += " g-raporHazirlaniyor";
            else if (item.Status == TenantStatus.raporHazirlandi)
                klass += " g-raporHazirlandi";
            else if (item.Status == TenantStatus.kiralandi)
                klass += " g-kiralandi";

            return Q.trimToNull(klass);
        }

        protected addButtonClick() {
            this.checkCreditAndContinue(() => super.addButtonClick());
        }

        protected checkCreditAndContinue(action: () => void) {
            SorAraBul.Administration.UserCreditService.GetCredit({}, response => {
                if ((response.Credit || 0) < 1) {
                    this.showInsufficientCreditDialog();
                    return;
                }

                action();
            });
        }

        private showInsufficientCreditDialog() {
            if (this.insufficientCreditDialog) {
                this.insufficientCreditDialog.dialog('open');
                return;
            }

            this.insufficientCreditDialog = $('<div/>')
                .text('Yetersiz kredi. Lütfen kredi satın aldıktan sonra tekrar deneyin.');

            this.insufficientCreditDialog.dialog({
                modal: true,
                title: 'Yetersiz Kredi',
                width: 430,
                close: () => {
                    this.insufficientCreditDialog.dialog('destroy').remove();
                    this.insufficientCreditDialog = null;
                },
                buttons: [
                    {
                        text: 'Kapat',
                        click: () => this.insufficientCreditDialog.dialog('close')
                    },
                    {
                        text: 'Kredi Satın Al',
                        class: 'btn-primary',
                        click: () => {
                            this.insufficientCreditDialog.dialog('close');
                            window.location.href = Q.resolveUrl('~/credit-purchase');
                        }
                    }
                ]
            });
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            var c_name = Q.first(columns, x => x.field == fld.NameSurname);
            if (c_name) {
                c_name.cssClass = Q.trimToNull((c_name.cssClass || '') + ' col-tenant-name');
                c_name.format = ctx => this.formatTenantName(ctx.item);
            }

            var c_property = Q.first(columns, x => x.field == fld.PropertyFullName);
            if (c_property) {
                c_property.cssClass = Q.trimToNull((c_property.cssClass || '') + ' col-property');
                c_property.format = ctx => this.formatPropertyName(ctx.value);
            }

            var c_durum = Q.first(columns, x => x.field == fld.Status);
            c_durum.cssClass = Q.trimToNull((c_durum.cssClass || '') + " col-durum");
            c_durum.format = ctx => this.formatStatus(ctx.value);

            var c_action = Q.first(columns, x => x.field == 'TenantAction');
            if (c_action) {
                c_action.name = 'Aksiyon';
                c_action.cssClass = Q.trimToNull((c_action.cssClass || '') + ' col-tenant-action');
                c_action.format = ctx => this.formatAction(ctx.item);
            }

            return columns;
        }


        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            var self = this;

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.parent().hasClass('tenant-detail'))
                target = target.parent();

            if (target.parent().hasClass('tenant-row-action'))
                target = target.parent();


            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Kiracıyı silmek istediğinizden emin misiniz? Bu işlemin ardından kiracıya ait kullanılan kredi hesabınıza iade edilecektir.', () => {
                        PropertyManagement.TenantsService.Delete({
                            EntityId: item.Id
                        }, resp => {
                            self.refresh();
                        });
                    });
                }
            } else if (target.hasClass('tenant-detail') || target.hasClass('tenant-row-action-detail')) {
                e.preventDefault();

                new TenantDetailPanelDialog().loadByIdAndOpenDialog(item.TenantDetailGId);
            }

        }

        private createTenantSummary() {
            this.tenantSummary = $(`
                <div class="tenant-summary-panel">
                    <div class="tenant-summary-cards">
                        <div class="tenant-summary-card tenant-total"><span class="tenant-summary-icon"><i class="fa fa-users"></i></span><span class="tenant-summary-label">Toplam Kiracı</span><strong data-metric="total">0</strong></div>
                        <div class="tenant-summary-card tenant-form"><span class="tenant-summary-icon"><i class="fa fa-link"></i></span><span class="tenant-summary-label">Form Gönderildi</span><strong data-metric="form">0</strong></div>
                        <div class="tenant-summary-card tenant-progress"><span class="tenant-summary-icon"><i class="fa fa-clock-o"></i></span><span class="tenant-summary-label">Rapor Hazırlanıyor</span><strong data-metric="progress">0</strong></div>
                        <div class="tenant-summary-card tenant-ready"><span class="tenant-summary-icon"><i class="fa fa-check"></i></span><span class="tenant-summary-label">Rapor Hazırlandı</span><strong data-metric="ready">0</strong></div>
                    </div>
                    <div class="tenant-status-chips">
                        <button type="button" class="tenant-status-chip active" data-status="">Tümü</button>
                        <button type="button" class="tenant-status-chip" data-status="${TenantStatus.formGonderildi}">Form Gönderildi</button>
                        <button type="button" class="tenant-status-chip" data-status="${TenantStatus.raporHazirlaniyor}">Rapor Hazırlanıyor</button>
                        <button type="button" class="tenant-status-chip" data-status="${TenantStatus.raporHazirlandi}">Rapor Hazırlandı</button>
                    </div>
                </div>`);

            this.tenantSummary.on('click', '.tenant-status-chip', e => {
                var button = $(e.currentTarget);
                var status = Q.trimToNull(button.attr('data-status'));

                this.activeStatusFilter = status == null ? null : parseInt(status, 10) as TenantStatus;
                this.tenantSummary.find('.tenant-status-chip').removeClass('active');
                button.addClass('active');
                this.refresh();
            });

            var title = this.element.find('.grid-title');
            if (title.length)
                this.tenantSummary.insertAfter(title);
            else
                this.element.prepend(this.tenantSummary);
        }

        private updateTenantSummary(items: TenantsRow[], totalCount: number) {
            if (!this.tenantSummary)
                return;

            var formCount = 0;
            var progressCount = 0;
            var readyCount = 0;

            for (var item of items) {
                if (item.Status == TenantStatus.formGonderildi)
                    formCount++;
                else if (item.Status == TenantStatus.raporHazirlaniyor)
                    progressCount++;
                else if (item.Status == TenantStatus.raporHazirlandi)
                    readyCount++;
            }

            this.tenantSummary.find('[data-metric=total]').text(totalCount || items.length);
            this.tenantSummary.find('[data-metric=form]').text(formCount);
            this.tenantSummary.find('[data-metric=progress]').text(progressCount);
            this.tenantSummary.find('[data-metric=ready]').text(readyCount);
        }

        private formatTenantName(item: TenantsRow): string {
            var name = Q.htmlEncode(Q.coalesce(item.NameSurname, '').trim() || '-');
            var phone = Q.htmlEncode(Q.coalesce(item.Phone, ''));
            return `<div class="tenant-name-cell"><strong>${name}</strong><span>${phone}</span></div>`;
        }

        private formatPropertyName(value: string): string {
            var text = Q.htmlEncode(Q.coalesce(value, '-'));
            return `<div class="tenant-property-cell" title="${Q.attrEncode(value || '')}">${text}</div>`;
        }

        private formatStatus(status: TenantStatus): string {
            var text = Serenity.EnumFormatter.format(TenantStatus, status);
            var css = 'tenant-status-badge';
            var icon = 'fa fa-circle-o';

            if (status == TenantStatus.formGonderildi) {
                css += ' tenant-status-form';
                icon = 'fa fa-link';
            }
            else if (status == TenantStatus.raporHazirlaniyor) {
                css += ' tenant-status-progress';
                icon = 'fa fa-clock-o';
            }
            else if (status == TenantStatus.raporHazirlandi) {
                css += ' tenant-status-ready';
                icon = 'fa fa-check';
            }
            else if (status == TenantStatus.kiralandi) {
                css += ' tenant-status-rented';
                icon = 'fa fa-key';
            }

            return `<span class="${css}"><i class="${icon}"></i>${Q.htmlEncode(text)}</span>`;
        }

        private formatAction(item: TenantsRow): string {
            var actions: string[] = [];

            if (item.Status == TenantStatus.formGonderildi && Q.trimToNull(item.Link)) {
                var fullUrl = `${window.location.origin}${item.Link}`;
                actions.push(`<a href="${Q.attrEncode(fullUrl)}" target="_blank" rel="noopener noreferrer" class="tenant-row-action tenant-row-action-link" title="Form linkini aç"><i class="fa fa-link"></i><span>Form</span></a>`);
            }

            if (item.Status == TenantStatus.raporHazirlaniyor || item.Status == TenantStatus.raporHazirlandi) {
                actions.push(`<a href="javascript:;" class="tenant-row-action tenant-row-action-detail" title="Bilgileri görüntüle"><i class="fa fa-eye"></i><span>Bilgiler</span></a>`);
            }

            if (item.Status == TenantStatus.raporHazirlandi && Q.trimToNull(item.SorsLocalReportUrl)) {
                actions.push(`<a href="${Q.attrEncode(item.SorsLocalReportUrl)}" target="_blank" rel="noopener noreferrer" class="tenant-row-action tenant-row-action-report" title="Raporu aç"><i class="fa fa-file-text-o"></i><span>Rapor</span></a>`);
            }

            return actions.length ? `<div class="tenant-action-group">${actions.join('')}</div>` : '';
        }
    }
}
